import React, { Component } from 'react';
import axios from 'axios'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { Form, Segment, Button, Divider, } from 'semantic-ui-react'
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class AddVatToProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }


    sendVatAmount = () => {
        console.log("++++++++:markDeliveryDate");
        console.log("this.props.projectId:" + this.props.projectId)
        console.log("this.props.user.email:" + this.props.user.email)
        console.log("dateNum:" + this.state.dateNum)

        if (this.props.projectId == '') {
            alert("No projectId Person")
        } else if (this.props.user.email == '') {
            alert("No Entered By Provided")
        } else if (this.state.vatAmount == '') {
            alert("No vatAmount Selected")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'applyVatToProject', {
                apiKey: "asdfasd##",
                projectId: this.props.projectId,
                enteredBy: this.props.user.email,
                vatAmount: this.state.vatAmount
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding project");

                        alert(response.data.message);
                        history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    payVatToExpenseAccount = () => {
        console.log("pvtx1 ++++++++:markDeliveryDate");
        console.log("pvtx12 this.props.projectId:" + this.props.projectId)
        console.log("pvtx13 this.props.user.email:" + this.props.user.email)

        if (this.props.projectId == '') {
            alert("No projectId Person")
        } else if (this.props.user.email == '') {
            alert("No Entered By Provided")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'payVatToExpenseAccount', {
                apiKey: "asdfasdf@da7",
                projectId: this.props.projectId,
                enteredBy: this.props.user.email,
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding vat to payVatToExpenseAccount");

                        alert(response.data.message);
                        history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    render() {

        const setVatButton = this.state.vatAmount != ''
            ? <Button color='violet'>SET VAT</Button>
            : ''


        const enterVatAmount =
            <div>
                <Divider horizontal>{' ADD VAT TO PROJECT'}</Divider>

                <Form size='large' onSubmit={this.sendVatAmount}>
                    
                        <h3>ENTER VAT AMOUNT</h3>
                        <label>Enter VAT AMOUNT</label>
                        <Form.Input
                            fluid
                            icon='money'
                            iconPosition='left'
                            placeholder='Vat Amount'
                            type='text'
                            name="vatAmount"
                            value={this.state.vatAmount}
                            onChange={this.handleTextInputChange}
                        />

                        {setVatButton}
                   
                </Form>
            </div>

        const setVatForPayment = this.props.project.paymentstatus 
        && this.props.project.paymentstatus == 'paid'
        && this.props.project.orderdelivered == 'yes'
        && this.props.project.vatamount
        && this.props.project.vatputinexpenseaccount != 'yes'
        ?
            <div>

                <Form size='large' onSubmit={this.payVatToExpenseAccount}>
         
                        <h3>MARK VAT FOR PAYMENT (IF ORDER IS FULLY PAID AND DELIVERED</h3>
                        <Button color='teal'>SET VAT FOR PAYMENT </Button>
         
                </Form>
            </div>
        :''

        return (this.state.loading ? <UiConsts.LoadingComponent /> : 
        <div>
            <Segment>
            {enterVatAmount}
            <br/>
            {setVatForPayment}
            </Segment>
          
   
        </div>);
    }
}

export default AddVatToProject;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/AddVatToProject.js